const HowItWorks = ({ language }: { language: string }) => {
  const steps = [
    {
      title: "Upload a recording or paste a link",
      detail: `Drop in a podcast episode, stream VOD or interview, or paste a YouTube link. Pick ${language} in the language selector so the audio is not left on auto detect.`,
    },
    {
      title: `Crayo transcribes the ${language} speech`,
      detail: `AutoClip transcribes the whole recording in ${language}, finds the strongest moments and cuts them into vertical clips with word-timed captions.`,
    },
    {
      title: "Style the captions and export",
      detail:
        "Choose one of 32 caption styles, fix any word in the caption list, then export clips ready for TikTok, Instagram Reels and YouTube Shorts.",
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-[20px] font-semibold tracking-tight text-[#101828] sm:text-[22px]">
        How it works
      </h2>
      <ol className="flex flex-col gap-3">
        {steps.map((step, index) => (
          <li
            key={step.title}
            className="flex gap-4 rounded-2xl border border-[#EFF2FF] bg-white px-5 py-4 shadow-sm"
          >
            <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-[#335CFF] text-[13px] font-semibold text-white">
              {index + 1}
            </span>
            <div className="flex flex-col gap-1">
              <span className="text-[15px] font-semibold text-[#101828]">{step.title}</span>
              <span className="text-[14.5px] leading-[1.65] text-[#525866]">{step.detail}</span>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default HowItWorks;
